module.exports = "query exercisePaths {\n  entries(section: [\"exercises\"], limit: 1) {\n    id\n    uri\n  }\n}"